export default "__VITE_ASSET__Be44BNQv__"